export const lunchroom = {
  seo: {
    title: 'Cas client : Two-B Lunchroom | Bistroo',
    description: "Comment Two-B, les meilleures sandwicheries de la région, s'est développée en ligne grâce à Bistroo.",
  },
  hero: {
    title: 'Two-B "les meilleurs sandwichs de la région" se développe en ligne grâce à Bistroo',
    description:
      'Two B by Mondie est une adresse bien connue à Veldhoven et ses environs, et a récemment ouvert un nouvel établissement à Helmond & Best. Ils servent toute la région avec de délicieux sandwichs.',
  },
  testimonials: {
    1: {
      text: '"Bistroo nous fait gagner beaucoup de temps chaque jour et réduit considérablement la frustration chez nos clients."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner',
    },
    2: {
      text: '"Le menu est facile à modifier et offre aux clients un aperçu clair."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner',
    },
  },
  challenge: {
    paragraph: {
      title: 'L\'innovation prend du temps',
      text: 'Auparavant, les commandes téléphoniques et le retrait au comptoir étaient les principaux moyens de servir les clients, ce qui entraînait de longues files d\'attente et des inefficacités pendant les moments chargés. Le propriétaire, Lars, collabore avec Bistroo depuis plus de 2 ans et partage volontiers quelques défis qu\'ils ont rencontrés avant la collaboration, ainsi que les solutions qu\'apporte Bistroo.',
    },
    paragraph_2: {
      title: 'Le défi',
      bullets: {
        1: 'Two B By Mondie était souvent confronté à l\'affluence pendant les heures de déjeuner, ce qui entraînait de longues files d\'attente et des clients moins satisfaits.',
        2: 'Les commandes par téléphone causaient des retards et de la confusion, surtout pendant les heures chargées.',
        3: 'En raison des erreurs humaines et des mauvaises communications lors des commandes téléphoniques, les commandes arrivaient parfois incorrectement, ce qui entraînait des clients insatisfaits et du temps perdu.',
        4: 'Les clients voulaient de plus en plus commander en ligne pour la commodité et s\'attendaient à une expérience de retrait sans faille sans longues files d\'attente.',
      },
    },
  },
  solution: {
    title: 'La solution',
    checklist: {
      1: 'Grâce à Bistroo, les clients pouvaient passer leurs commandes à l\'avance, permettant à Two B By Mondie de travailler plus efficacement pendant les moments chargés et aux clients de retirer immédiatement sans attendre.',
      2: "Avec la solution de commande en ligne de Bistroo, Two B By Mondie disposait d'un aperçu clair des commandes, ce qui réduisait les erreurs et permettait à la cuisine de travailler plus efficacement.",
      3: 'Avec Bistroo, Two B By Mondie pouvait gérer ses propres périodes chargées, ce qui leur permettait d\'améliorer l\'expérience client et de maximiser le chiffre d\'affaires.',
      4: 'Toutes les commandes via Bistroo étaient payées à l\'avance, ce qui réduisait le risque de commandes non récupérées et assurait une gestion plus fluide au comptoir.',
    },
  },
  conclusion: {
    title: 'La conclusion',
    text: {
      1: 'La solution de commande en ligne de Bistroo a offert à Two B By Mondie non seulement un moyen efficace de relever ces défis, mais a également transformé leur gestion. "Depuis que nous collaborons avec Bistroo, nos clients peuvent facilement passer leurs commandes en ligne. Cela nous fait gagner beaucoup de temps chaque jour et réduit considérablement la frustration chez nos clients", selon Lars. Il apprécie également la facilité d\'utilisation du système de modification des menus et l\'excellent service client de Bistroo : "Quand nous avons des questions, nous obtenons une aide rapide et compétente."',
      2: "De plus, Bistroo propose toujours une période d'essai de 30 jours pendant laquelle les clients peuvent utiliser le service gratuitement. Dans presque tous les cas, il existe une intention mutuelle de continuer à utiliser la solution de commande en ligne de Bistroo, ce qui témoigne de la valeur et de l'efficacité du logiciel de commande pour des établissements comme Two B By Mondie.",
    },
  },
}
